import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Box, Typography, Grid, Button } from '@material-ui/core';
import Lizy from '/lib/component/base/Lizy';
import { useApolloClient } from '/lib/component/util';
import invalidateTokens from '/lib/mutation/invalidateTokens';

const styles = theme => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  headline: {
    ...theme.typography.monospace,
    fontSize: 104,
    fontWeight: 800,
  },
  body: {
    maxWidth: '65ch',
    '& a': {
      textDecoration: 'underline',
    },
    '& a:visited': {
      color: 'inherit',
    },
    '& a:link': {
      color: 'inherit',
    },
  },
  graphic: {
    margin: theme.spacing(-12, 0),
  },
  [theme.breakpoints.up('sm')]: {
    root: {
      textAlign: 'left',
    },
    graphic: {
      margin: 0,
      textAlign: 'right',
    },
  },
});

const NotFound = ({ classes, children }) => {
  const client = useApolloClient();

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={2} sm={4} className={classes.graphic}>
          <Box component={Lizy} variant="idle" height="36vh" />
        </Grid>
        <Box
          component={Grid}
          item
          xs={12}
          sm={6}
          display="flex"
          justifyContent="center"
          flexDirection="column"
        >
          <Typography className={classes.headline} variant="h1" color="textPrimary">
            Access Blocked
          </Typography>
          <Typography className={classes.body} variant="body2" color="textSecondary">
            {children}
          </Typography>
          <Button variant="contained" size="large" onClick={() => invalidateTokens(client)}>
            Sign Out
          </Button>
        </Box>
      </Grid>
    </div>
  );
};

NotFound.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  children: PropTypes.node,
};

NotFound.defaultProps = {
  children: (
    <React.Fragment>
      The page you requested was not found.{' '}
      <a href="#back" onClick={() => window.history.back()}>
        Go back
      </a>{' '}
      or <a href="/">return home</a>.
    </React.Fragment>
  ),
};

export default withStyles(styles)(NotFound);
